import Vue from 'vue'

export default {
    storeEvents(state, eventPagination) {
        this.commit('clearEvents')
        state.event_pages = eventPagination.last_page
        eventPagination.data.forEach((event) => {
            Vue.set(event, 'page', eventPagination.current_page)
            this.commit('storeEvent', event)
        })
    },
    storeEvent(state, event) {
        const eventIndex = state.events.findIndex(item => item.id === event.id)
        if (eventIndex === -1) {
            state.events.push(event)
        } else {
            if (state.events[eventIndex].page) {
                Vue.set(event, 'page', state.events[eventIndex].page)
            }
            Vue.set(state.events, eventIndex, event)
        }
    },
    clearEvents(state) {
        Vue.set(state, 'events', [])
    },
    resetNewEvent(state) {
        state.new_event = {
            name: '',
              description: '',
              start: new Date().toDateString(),
              end: new Date().toDateString()
        }
    },
    storeCalendars(state, calendars) {
        state.calendars = calendars
    },
    storeCalendar(state, calendar) {
        const calendarIndex = state.calendars.findIndex(item => item.id === calendar.id)
        if (calendarIndex === -1) {
            state.calendars.push(calendar)
        } else {
            if (state.calendars[calendarIndex].page) {
                Vue.set(calendar, 'page', state.calendars[calendarIndex].page)
            }
            Vue.set(state.calendars, calendarIndex, calendar)
        }
    },
    clearCalendars(state) {
        Vue.set(state, 'calendars', [])
    },
    resetNewCalendar(state) {
        state.new_calendar = {
            name: '',
            description: '',
            color: '#dc3545'
        }
    },
    none () {
    }
}
